import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

import axios from 'axios'

const routes = [
  {
    path: '/admin/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/admin/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/admin/teacherList',
    name: 'teacherList',
    component: () => import(/* webpackChunkName: "about" */ '../views/TeacherList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/schoolList',
    name: 'schoolList',
    component: () => import(/* webpackChunkName: "about" */ '../views/SchoolList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/scheduleList',
    name: 'scheduleList',
    component: () => import(/* webpackChunkName: "about" */ '../views/ScheduleList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/holidayList',
    name: 'holidayList',
    component: () => import(/* webpackChunkName: "about" */ '../views/HolidayList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/classList',
    name: 'classList',
    component: () => import(/* webpackChunkName: "about" */ '../views/ClassList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/changeList',
    name: 'changeList',
    component: () => import(/* webpackChunkName: "about" */ '../views/ChangeList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/calList',
    name: 'calList',
    component: () => import(/* webpackChunkName: "about" */ '../views/CalList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/invoiceList',
    name: 'invoiceList',
    component: () => import(/* webpackChunkName: "about" */ '../views/InvoiceList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/calcList',
    name: 'calcList',
    component: () => import(/* webpackChunkName: "about" */ '../views/CalcList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})



router.beforeEach(async (to, from, next) => {
  // 세션 확인 로직
  var isAuthenticated = await checkSession(); // 세션 확인 함수 구현
  console.log('abcd');
  console.log("isAuthenticated : " + isAuthenticated);
  console.log(to.matched.some(route => route.meta.requiresAuth));
  if (to.matched.some(route => route.meta.requiresAuth)) {
    // 해당 라우트가 requiresAuth 메타 필드를 가지고 있으면
    if (!isAuthenticated) {
      // 세션이 없으면 로그인 페이지로 이동
      console.log('login페이지');
      next('/admin/login');
    } else {
      console.log('next()');
      next();
    }
  } else {
    next();
  }
});



export default router

async function checkSession() {
  // 세션 확인 로직을 여기에 구현
  // 세션이 있으면 true, 없으면 false 반환


  if(localStorage.getItem('userid') == 'admin'){
    return true;
  }

  return false;
  /*
  var chk = false;

  await axios
      .get(process.env.VUE_APP_BASEURL + '/api/login/sessionCheck', {})
      .then((res) => {
        console.log(res.data.userid)
        if(res.data.userid == 'admin'){
          chk = true;
        }
       
      })
      .catch((error) => {
        console.log(error);
        alert('오류가 발생했습니다.');
      });

  return chk;
  console.log('end')
  */
  //return false; // 예제로 기본적으로 세션이 없다고 가정
}
